export default "<p>\r\n  User not authorized to use this site. Please contact an administrator for\r\n  access.\r\n</p>\r\n"